import { BREAKPOINTS } from '../config';
import { lenis } from '../layout/lenis';
import { ScrollBus } from '../layout/scroll-bus';

const sidebar = document.querySelector('.sidebar');
if (sidebar) {
  tabsSidebar(sidebar);
}

let currentActiveLink = null;

function tabsSidebar(page) {
  const header = document.querySelector('.header');
  const headerHeight = header?.offsetHeight || 0;
  const sidebarList = page.querySelector('.sidebar-list');
  const sidebarBody = page.querySelector('.sidebar-body');

  let titles = page.querySelectorAll('.sidebar-content h2');
  if (titles.length < 1) {
    titles = page.querySelectorAll('.sidebar-content h3');
  }

  if (!sidebarList || !sidebarBody || titles.length === 0) return;

  titles.forEach((title, index) => {
    title.setAttribute('id', `title-${index + 1}`);
  });

  const isOrdered = sidebarList.hasAttribute('data-ol');
  const list = document.createElement(isOrdered ? 'ol' : 'ul');
  list.classList.add('sidebar-tabs', 'ankor');

  titles.forEach((title, index) => {
    const li = document.createElement('li');
    const a = document.createElement('a');
    const span = document.createElement('span');

    a.className = index === 0 ? 'active tab' : 'tab';
    a.setAttribute('href', `#title-${index + 1}`);

    span.textContent = title.textContent;

    a.appendChild(span);
    li.appendChild(a);
    list.appendChild(li);
  });

  sidebarList.innerHTML = '';
  sidebarList.appendChild(list);

  const links = list.querySelectorAll('a');
  const headers = Array.from(links).map((_, i) =>
    document.getElementById(`title-${i + 1}`)
  );

  function getSidebarBodyTop() {
    if (!sidebarBody) return 0;
    return Math.round(sidebarBody.getBoundingClientRect().top + window.scrollY);
  }
  function getSidebarTopValue() {
    const sidebarListTop = parseFloat(getComputedStyle(sidebarList).top);
    if (sidebarListTop) return sidebarListTop;

    const aside = sidebarList.closest('aside');
    if (!aside) return 0;

    return parseFloat(getComputedStyle(aside).top) || 0;
  }

  function setActiveLink(scrollTop) {
    const topValue = getSidebarTopValue();
    const sidebarBodyTop = getSidebarBodyTop();

    const trigger = scrollTop + headerHeight + topValue + 10;

    let activeLink = links[0];

    headers.forEach((header, i) => {
      if (sidebarBodyTop + header.offsetTop <= trigger) {
        activeLink = links[i];
      }
    });

    if (activeLink !== currentActiveLink) {
      links.forEach(link => link.classList.remove('active'));
      activeLink.classList.add('active');
      syncMobileMenu(activeLink);
      currentActiveLink = activeLink;
    }
  }

  function syncMobileMenu(activeLink) {
    if (window.innerWidth > BREAKPOINTS.mqTouch) return;

    const container = sidebarList;
    const rect = activeLink.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();

    const offset =
      rect.left - containerRect.left - containerRect.width / 2 + rect.width / 2;

    container.scrollTo({
      left: container.scrollLeft + offset,
      behavior: 'smooth',
    });
  }

  ScrollBus.on(scrollTop => {
    setActiveLink(scrollTop);
  });

  document.querySelectorAll('.ankor a').forEach(anchor => {
    anchor.addEventListener('click', e => {
      e.preventDefault();

      const target = document.querySelector(anchor.getAttribute('href'));
      const topValue = getSidebarTopValue();
      const sidebarBodyTop = getSidebarBodyTop();

      const y = sidebarBodyTop + target.offsetTop - headerHeight - topValue;

      lenis.scrollTo(y);
    });
  });
}
